import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HappyPayWithdrawal } from '../interfaces/happy-pay.interface';

const apiUrl = environment.apiUrl + 'user/happy_pay_withdrawal';

@Injectable({
  providedIn: 'root',
})
export class HappyPayWithdrawalService {
  newHPWithdrawState: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private messageService: MessageService
  ) {}

  setNewHpWithdrawState(value: any) {
    this.newHPWithdrawState.next(value);
  }

  getNewHPWithdrawState() {
    return this.newHPWithdrawState.asObservable();
  }

  getHappyPayWithdrawals(
    itemPerPage: number,
    currentPage: number = 1,
    dateFilter: any = null
  ) {
    const body = {
      item_per_page: itemPerPage,
      current_page: currentPage,
      start_date: dateFilter ? dateFilter.start : null,
      end_date: dateFilter ? dateFilter.end : null,
      sorts: [{ field: 'created_at', direction: 'DESC' }],
    };
    return this.http
      .post(apiUrl + '/search', body)
      .pipe(
        map((res: any) => {
          let withdrawals: HappyPayWithdrawal[] = res.data.happypay_withdrawals;
          withdrawals.forEach((withdraw) => {
            if (withdraw.confirmed_at)
              withdraw.formatted_confirmed_at =
                this.datePipe.transform(
                  new Date(withdraw.confirmed_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
            if (withdraw.created_at)
              withdraw.formatted_created_at =
                this.datePipe.transform(
                  new Date(withdraw.created_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
            if (withdraw.updated_at)
              withdraw.formatted_update_at =
                this.datePipe.transform(
                  new Date(withdraw.updated_at),
                  'dd MMM yyyy, HH:mm'
                ) || '';
          });
          return { totalItems: res.data.total_items, withdrawals: withdrawals };
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  addHappyPayWithdrawal(newWithdrawal: HappyPayWithdrawal) {
    return this.http.post(apiUrl, newWithdrawal).pipe(
      map((res: any) => {
        this.handleSuccess('Berhasil melakukan withdraw happy pay');
        return res;
      })
    );
  }

  deleteHappyPayWithdrawal(withdrawalId: number) {
    return this.http.delete(apiUrl + '/' + withdrawalId).pipe(
      map((res: any) => {
        this.handleSuccess('Berhasil membatalkan withdraw happy pay');
        return res;
      })
    );
  }

  private handleSuccess(message: any) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: message,
    });
  }
}
